export const agIconLoadingTemplate: string = `
  <span class="ag-icon ag-icon-loading kpi-ag-loading-icon" role="presentation" unselectable="on"></span>
`;
